// extracted by mini-css-extract-plugin
export var badge = "Tab-module--badge--148dc";
export var checkmark = "Tab-module--checkmark--970ea";
export var ctaButton = "Tab-module--cta-button--4b7b7";
export var divider = "Tab-module--divider--d6abb";
export var emerald = "Tab-module--emerald--0a514";
export var featureList = "Tab-module--feature-list--e4157";
export var featureTableButton = "Tab-module--feature-table-button--9a5ae";
export var gold = "Tab-module--gold--5d984";
export var grid = "Tab-module--grid--82c1d";
export var headingIcon = "Tab-module--heading-icon--83c64";
export var introCopy = "Tab-module--intro-copy--62a59";
export var level = "Tab-module--level--540d5";
export var lilac = "Tab-module--lilac--86d98";
export var mainContent = "Tab-module--main-content--420c9";
export var open = "Tab-module--open--f9fdb";
export var pink = "Tab-module--pink--7ef7a";
export var planLevels = "Tab-module--plan-levels--a5150";
export var tab = "Tab-module--tab--1551a";
export var tabHeading = "Tab-module--tab-heading--b09f3";